import React from 'react';
import Layout from '../components/base/Layout';
import ProjectItems from '../components/Projects/ProjectItems';

const Projects = () => {
    return (
        <Layout>
            <ProjectItems />
        </Layout>
    );
};

export default Projects;
